import { FC, SetStateAction, Dispatch, ReactNode } from 'react';

import { ReactComponent as ArrowIcon } from 'assets/icons/carousel-arrow.svg';

import s from './index.module.scss';

type CarouselProps = {
	style?: { [key: string]: string };
	length: number;
	onSetCurrent: Dispatch<SetStateAction<number>>;
	current: number;
	children: ReactNode;
};

export const Carousel: FC<CarouselProps> = ({ style, length, current, onSetCurrent, children }) => {
	const onPrev = () => {
		const newIndex = (current - 1 + length) % length;
		onSetCurrent(newIndex);
	};

	const onNext = () => {
		const newIndex = (current + 1) % length;

		onSetCurrent(newIndex);
	};

	const isMany = length > 1;
	return (
		<div className={s.root} style={style}>
			{isMany && (
				<button className={s.arrow} onClick={onPrev}>
					<ArrowIcon />
				</button>
			)}
			{children}
			{isMany && (
				<button className={`${s.arrow} ${s.next}`} onClick={onNext}>
					<ArrowIcon />
				</button>
			)}
		</div>
	);
};
